export const SERVER = process.env.REACT_APP_API_URL;

export const API = `${SERVER}/`;
